<template>
  <div class="container container-message text-center">
    <h1 class="alert-heading">{{ $t('notFoundHeading')}}</h1>
    <p>
      {{ $t('notFoundBody1')}}
    </p>
    <p>
      {{ $t('notFoundBody2')}}
    </p>
    <router-link to="/vacation-calendar/" class="btn custom-button">{{ $t('notFoundReturn')}}</router-link>
  </div>
</template>

<script>
export default {
  name: 'NotFound',
};
</script>

<style scoped>

</style>
